import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { loginAdmin, logoutAdmin } from "./adminApi";

const AdminAuthContext = createContext(null);
const ADMIN_STORAGE_KEY = "ashoka-admin-auth";

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem(ADMIN_STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (user) {
      localStorage.setItem(ADMIN_STORAGE_KEY, JSON.stringify(user));
    } else {
      localStorage.removeItem(ADMIN_STORAGE_KEY);
    }
  }, [user]);

  const login = async ({ username, password }) => {
    const response = await loginAdmin({ username, password });
    setUser(response.user);
    return response.user;
  };

  const logout = async () => {
    try {
      await logoutAdmin();
    } catch {
      // Local logout should still happen if the server session is already gone.
    }
    setUser(null);
  };

  const value = useMemo(
    () => ({ user, login, logout, isAuthenticated: Boolean(user) }),
    [user]
  );

  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
}

export function useAdminAuth() {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error("useAdminAuth must be used within AdminAuthProvider");
  }
  return context;
}
